<div class="row" *ngIf="service && service.serviceJsonProperties">
    <div class="col-12 col-md-12 pl-4 pr-4">
        <div class="form-group">

            <div class="row mb-4">
                <div class="col">
                    <label class="input-label">{{ 'Run service debug script' | translate }}</label>
                    <dry-run [serviceId]="serviceId" (resultsUpdated)="onDebugResultsUpdated($event)"></dry-run>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <label class="input-label">{{ 'Duplicated keys' | translate }}</label>
                    <div class="table-items">
                        <div class="item">
                            <div class="row cursor-row" (click)="
                            service.serviceJsonProperties.enableDuplicatedKeysVerification = !service
                            .serviceJsonProperties
                            .enableDuplicatedKeysVerification; autoSave('Pages'); checkDuplicatedKeys();
                            ">
                                <div class="col-auto align-items-center justify-content-end">
                                    <em id="enableDuplicatedKeysVerification" class="fas {{
                                        service.serviceJsonProperties &&
                                        service.serviceJsonProperties
                                        .enableDuplicatedKeysVerification
                                        ? 'fa-toggle-large-on toggle-primary'
                                        : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                                    }}" style="vertical-align: middle;"></em>
                                </div>
                                <div class="col pl-0">
                                    <label>{{ 'Enable duplicated keys verification' | translate }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="item" *ngIf="service.serviceJsonProperties &&
                        service.serviceJsonProperties
                        .enableDuplicatedKeysVerification">
                            <div class="row">
                                <div class="col-1 align-items-center justify-content-end"></div>
                                <div class="col">
                                    <ul class="list">
                                        <ng-container *ngFor="let key of duplicatedKeys">
                                            <li>
                                                <b>{{key.key}}</b>
                                                <ul class="list">
                                                    <ng-container *ngFor="let occurence of key.occurences">
                                                        <li class="text-danger">{{occurence.fullName}}</li>
                                                    </ng-container>
                                                </ul>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>